export { default } from './Loading';



// WEBPACK FOOTER //
// ./src/components/common/Loading/index.js